export const CUSTOM_HUB_FEATURE_NAME = 'custom-hub';
